<template>
  <div>
    <div class="contentFooter">
      <div class="EC_width display_between display_center_ud height_100">
        <a v-for="(item, index) in linksRotation"
           :key="index + 1"
           :href="item.url"
           target="_blank">
          <img :src="item.resUrl"
               width="190"
               height="50" />
        </a>
      </div>
    </div>
    <div class="cn_globe_footer">
      <div class="cn_globe_footer_bar EC_width">
        <div class="cn_footer_logo display_center_ud">
          <img style="height:82px"
               src="/image/index/footerlogo2.png" />
        </div>
        <div class="cn_footer_text">
          <div class="cn_footer_text_top">
            <span class="marginRight20">电话：010-83116337</span>
            <span>邮箱：chinagpweb@chinagp.net</span>
          </div>

          <div class="cn_footer_text_down">
            <span class="marginRight20">地址：北京市西城区广义街5号广益大厦A座907</span>
            <span>投诉：chinagp@vip.sina.com</span>
          </div>
        </div>
        <div class="cn_footer_icon">
          <a href="javascript:;"
             class="footer_icon_link">
            <img src="/image/index/icon1.png" />
          </a>
          <a href="javascript:;"
             class="footer_icon_link">
            <img src="/image/index/icon2.png" />
          </a>
          <a href="javascript:;"
             class="footer_icon_link">
            <img src="/image/index/icon3.png" />
          </a>
          <a href="javascript:;"
             class="footer_icon_link">
            <img src="/image/index/icon4.png" />
          </a>
          <a href="javascript:;"
             class="footer_icon_link">
            <img src="/image/index/icon5.png" />
          </a>
          <a href="javascript:;"
             class="footer_icon_link">
            <img src="/image/index/icon6.png" />
          </a>
        </div>
      </div>
    </div>
    <div class="cn_globe_footer_beian">
      <div class="EC_width">
        <span style="border-right: 1px solid #7b889b; padding-right: 10px; margin-right: 10px"> Copyright2023 北京华卫通科健康科技有限公司版权所有</span>
        <span style="border-right: 1px solid #7b889b; padding-right: 10px; margin-right: 10px">
          <a href="https://beian.miit.gov.cn"
             target="_blank"
             style="color: #7b889b;"> {{ ICPNumber }} </a>
        </span>
        <span>
          <a target="_blank"
             style="color: #7b889b;"
             :href="PublicNumberURl">
            <img style="margin-bottom:-4px"
                 src="/image/icon/gongan.png" />
            {{ PublicNumber }}
          </a>
          <img src="../../assets/img/icon/icon.gif" />
        </span>

        <a v-for="(itemlnike, indexlnike) in columntopList"
           :key="indexlnike"
           href="javascript:;"
           class="cn_footer_beian_link"
           :class="{ marginLeft50: indexlnike == 0 }"
           @click="columnclk(itemlnike)">
          {{ itemlnike.name }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      linksRotation: [],
      columntopList: [],
      ICPNumber: '京ICP备2021015394号-1',
      PublicNumber: '京公网安备 11010202009427号',
      PublicNumberURl: 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010202009427'
    };
  },
  created () {
    this.GetRotationInfo();
    this.GetColumsInfoAllList();
  },
  methods: {
    //获取轮播数据
    GetRotationInfo () {
      let res = {
        code: 200,
        msg: "获取轮播信息成功!",
        data: [
          {
            title: "首页底部友情链接",
            url: "https://www.cnki.net/",
            resUrl: "https://cgp-resource.oss-cn-beijing.aliyuncs.com/Images/UserHeadPict/20210525/a172adc63be4f2ec2952c2406043b4ac.jpg",
            detail: null,
            resRightUrl: null
          }, {
            title: "首页底部友情链接",
            url: "https://www.wanfangdata.com.cn/index.html",
            resUrl: "https://cgp-resource.oss-cn-beijing.aliyuncs.com/Images/UserHeadPict/20210525/2be49de7e131ef427b4f77ca340f7324.jpg",
            detail: null,
            resRightUrl: null
          }, {
            title: "3",
            url: "https://xhyxzz.pumch.cn/",
            resUrl: "https://cgp-resource.oss-cn-beijing.aliyuncs.com/Images/UserHeadPict/20210721/1a122e20aba7ae32ef985105e538f33a.png",
            detail: "3",
            resRightUrl: null
          }, {
            title: "2",
            url: "http://www.acsme.org.cn/",
            resUrl: "https://cgp-resource.oss-cn-beijing.aliyuncs.com/Images/UserHeadPict/20210202/e4aa6ee314fcbf74c30c6c0d49e37cf5.jpg",
            detail: "2",
            resRightUrl: null
          }, {
            title: "友情链接",
            url: "http://www.nhc.gov.cn/",
            resUrl: "https://cgp-resource.oss-cn-beijing.aliyuncs.com/Images/UserHeadPict/20210202/8b8043ac48a7a2e830e51e73632bff19.jpg",
            detail: "1",
            resRightUrl: null
          }]
      }
      if (res.code == 200) {
        this.linksRotation = res.data;
      }
    },
    //获取栏目数据
    GetColumsInfoAllList () {
      let res = {
        code: 200,
        msg: "查询成功!",
        data: [{
          id: 106,
          parentid: 0,
          name: "网站底部信息",
          status: 1,
          sort: 1,
          createtime: "2021-01-26 11:41:49",
          updatetime: "2021-01-26 11:41:49",
          type: 3,
          isCHorEN: 1
        }, {
          id: 107,
          parentid: 106,
          name: "隐私条款",
          status: 1,
          sort: 1,
          createtime: "2021-01-26 11:42:18",
          updatetime: "2021-01-26 11:42:18",
          type: 3,
          isCHorEN: 1
        }, {
          id: 108,
          parentid: 106,
          name: "注册协议",
          status: 1,
          sort: 1,
          createtime: "2021-01-26 11:42:39",
          updatetime: "2021-01-26 11:42:39",
          type: 3,
          isCHorEN: 1
        }, {
          id: 109,
          parentid: 106,
          name: "合作单位",
          status: 1,
          sort: 1,
          createtime: "2021-01-26 11:43:05",
          updatetime: "2021-01-26 11:43:05",
          type: 3,
          isCHorEN: 1
        }, {
          id: 110,
          parentid: 106,
          name: "cookie政策",
          status: 1,
          sort: 1,
          createtime: "2021-01-26 11:43:22",
          updatetime: "2021-01-26 11:43:22",
          type: 3,
          isCHorEN: 1
        }, {
          id: 111,
          parentid: 106,
          name: "联系我们",
          status: 1,
          sort: 1,
          createtime: "2021-01-26 11:43:33",
          updatetime: "2021-01-26 11:43:33",
          type: 3,
          isCHorEN: 1
        }, {
          id: 112,
          parentid: 106,
          name: "网站声明",
          status: 1,
          sort: 1,
          createtime: "2021-01-26 11:43:46",
          updatetime: "2021-01-26 11:43:46",
          type: 3,
          isCHorEN: 1
        }]
      }
      if (res.code == 200) {
        let data = res.data.sort(function (a, b) {
          return a.sort - b.sort;
        });
        data.forEach(item => {
          if (item.parentid == '106') {
            //首页底部信息
            this.columntopList.push(item);
          }
        })
      }
    },
    columnclk (item) {
      var contextid = 0;
      switch (item.id) {
        case 107:
          contextid = 758;
          break;
        case 108:
          contextid = 757;
          break;
        case 109:
          contextid = 464;
          break;
        case 110:
          contextid = 759;
          break;
        case 111:
          contextid = 221;
          break;
        case 112:
          contextid = 465;
          break;
      }
      const { href } = this.$router.resolve({
        path: '/home/inforDetails?',
        query: {
          id: contextid,
          column_Type: item.id
        }
      });
      window.open(href, '_blank');
    }
  }
};
</script>